import type { ReceiptPaymentMethod } from '../types';

export const PAYMENT_METHOD_LABELS: Record<ReceiptPaymentMethod, string> = {
  cash:          'Efectivo',
  check:         'Cheque',
  bank_transfer: 'Transferencia',
  qr:            'Transferencia',
};

export function formatMoney(n: number): string {
  return n.toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatReceiptDate(iso: string): string {
  return new Date(iso).toLocaleDateString('es-BO', {
    day: '2-digit', month: 'long', year: 'numeric',
  });
}

/** Formats a plain 'YYYY-MM-DD' (no timezone shift, unlike new Date(iso)) as DD/MM/YYYY. */
export function formatPlainDate(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
}

export function formatShortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('es-BO', {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });
}
